module.exports = __webpack_public_path__ + "static/media/mail.184ca930.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/pages/Home/images/mail.png
// module id = 82
// module chunks = 0